import { createSlice, current } from '@reduxjs/toolkit';




const initialState = {
  ordersDate:[]
};

export const ordersSlice = createSlice({
  name: 'orders',
  initialState,
  reducers: {
    setOrdersDate: (state, { payload }) => {
     
      state.ordersDate = [...payload];
    },
    
   
    clearOrdersState: (state) => {
      state=initialState
    }
  }
});

export const { setOrdersDate, clearOrdersState } = ordersSlice.actions;

export const ordersData = (state) => state.orders;


export default ordersSlice.reducer;
